var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgModal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 233,
    height: 175,
    viewBox: "0 0 233 175",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M232 57H179.043C177.363 57 176 58.9383 176 61.3293V123.671C176 126.062 177.363 128 179.043 128H232V123.671V61.3293V57Z",
    fill: "#718095",
    fillOpacity: 0.35
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M162.304 57H101.696C99.6546 57 98 58.9383 98 61.3293V123.671C98 126.062 99.6546 128 101.696 128H162.304C164.345 128 166 126.062 166 123.671V61.3293C166 58.9383 164.345 57 162.304 57Z",
    fill: "#718095",
    fillOpacity: 0.35
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_2728_574)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M183.848 9H50.1522C45.6499 9 42 13.2861 42 18.5732V156.427C42 161.714 45.6499 166 50.1522 166H183.848C188.35 166 192 161.714 192 156.427V18.5732C192 13.2861 188.35 9 183.848 9Z",
    fill: "#718095",
    fillOpacity: 0.49
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M169.696 34H66.3043C62.8226 34 60 35.4196 60 37.1707V82.8293C60 84.5804 62.8226 86 66.3043 86H169.696C173.177 86 176 84.5804 176 82.8293V37.1707C176 35.4196 173.177 34 169.696 34Z",
    fill: "#F3F6F9",
    fillOpacity: 0.7
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M172.68 112H65.3212C64.7722 112 64.3271 112.448 64.3271 113C64.3271 113.552 64.7722 114 65.3212 114H172.68C173.229 114 173.674 113.552 173.674 113C173.674 112.448 173.229 112 172.68 112Z",
    fill: "#6F6F6F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M170.406 115H68.7576C68.2378 115 67.8164 115.448 67.8164 116C67.8164 116.552 68.2378 117 68.7576 117H170.406C170.926 117 171.347 116.552 171.347 116C171.347 115.448 170.926 115 170.406 115Z",
    fill: "#6F6F6F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M164.663 118H71.0097C70.5308 118 70.1426 118.448 70.1426 119C70.1426 119.552 70.5308 120 71.0097 120H164.663C165.142 120 165.53 119.552 165.53 119C165.53 118.448 165.142 118 164.663 118Z",
    fill: "#6F6F6F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M156.397 121H78.114C77.5667 121 77.123 121.448 77.123 122C77.123 122.552 77.5667 123 78.114 123H156.397C156.945 123 157.388 122.552 157.388 122C157.388 121.448 156.945 121 156.397 121Z",
    fill: "#6F6F6F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M172.77 102H65.2133C62.1169 102 62 103.119 62 104.5C62 105.881 62.1169 107 65.2133 107H172.77C175.866 107 176 105.881 176 104.5C176 103.119 175.866 102 172.77 102Z",
    fill: "#D1D5DB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M148.595 95H88.2321C86.4943 95 86.4287 96.1193 86.4287 97.5C86.4287 98.8807 86.4943 100 88.2321 100H148.595C150.333 100 150.408 98.8807 150.408 97.5C150.408 96.1193 150.333 95 148.595 95Z",
    fill: "#D1D5DB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M184.558 15.1944C182.815 13.4271 179.962 13.4072 178.194 15.1499C176.427 16.8926 176.407 19.7464 178.15 21.5137C179.893 23.281 182.746 23.3009 184.514 21.5582C186.281 19.8154 186.301 16.9616 184.558 15.1944ZM183.065 20.791L181.349 19.0506L179.609 20.7668L178.917 20.0654L180.657 18.3492L178.941 16.6088L179.643 15.9171L181.359 17.6575L183.099 15.9412L183.798 16.6495L182.057 18.3658L183.767 20.0993L183.065 20.791Z",
    fill: "#F3F6F9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_2728_574",
    x: 20,
    y: -13,
    width: 194,
    height: 201,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2728_574"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2728_574",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModal);
export default __webpack_public_path__ + "static/media/modal.345e1cc165f8c1a1deb6629f50d29ab9.svg";
export { ForwardRef as ReactComponent };